module.exports = __webpack_public_path__ + "static/img/banner-1.54e7ab8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner-1.png
// module id = +Wq4
// module chunks = 11